import { oz } from '@weft/utils';
import { ErpMetadataSchema, SanitizedStringSchema } from '../../primitives';
import { AddressSchema } from '../../primitives/address-schema';
import { withNullAsOptional } from '../../utils/literal-transforms';
import { RevenueBreakdownSchema } from '../revenue-breakdown';
import { CustomerContractsSchema } from './customer-contracts-schema';
import { CustomerSettingsSchema } from './customer-settings-schema';
import { CustomerStatusSchema } from './customer-status-schema';

export const NewCustomerSchema = oz.object({
  name: SanitizedStringSchema,
  externalId: SanitizedStringSchema.nullish(),
  taxId: SanitizedStringSchema.nullish(),
  crmId:SanitizedStringSchema.nullish(),
  erpMetadata: withNullAsOptional(ErpMetadataSchema).nullable(),
  address: AddressSchema.optional(),
  contacts: CustomerContractsSchema.optional(),
  settings: CustomerSettingsSchema.nullable().optional(),
  revenueBreakdown: RevenueBreakdownSchema,
  status: CustomerStatusSchema.optional(),
}).openapi('NewCustomer');

export type NewCustomer = oz.infer<typeof NewCustomerSchema>;